import { ApolloClient, InMemoryCache } from '@apollo/client'

import { URL_ROOT } from './style-guide/branding-assets'

let host, client
if (
  process.env.RIPPLE_ENV === 'development' ||
  process.env.RIPPLE_ENV === 'testing'
) {
  host = `http://localhost:${process.env.BACKEND_PORT || 3000}`
} else if (process.env.RIPPLE_ENV === 'staging') {
  host = `https://staging.${URL_ROOT}`
} else if (process.env.RIPPLE_ENV === 'production') {
  host = `https://app.${URL_ROOT}`
} else if (process.env.RIPPLE_ENV?.startsWith('qa-')) {
  host = `https://${process.env.RIPPLE_ENV}.staging.strivemessaging.org`
}

if (process.env.RIPPLE_ENV !== 'testing') {
  client = new ApolloClient({
    uri: `${host}/api/graphql`,
    cache: new InMemoryCache()
  })
}

export default client
